import { render, staticRenderFns } from "./BulkBar.vue?vue&type=template&id=65bdf3a5"
import script from "./BulkBar.vue?vue&type=script&lang=js"
export * from "./BulkBar.vue?vue&type=script&lang=js"
import style0 from "./BulkBar.vue?vue&type=style&index=0&id=65bdf3a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports